import { useContext, useState } from 'react';

import { Image } from 'antd';

import { LayoutContext } from '../../baseLayout/provider';

import { CustomScrollbar } from './CustomScrollbar.style';

export default function MroCatalogsPop() {
  const [secondCatalogList, setSecondCatalogList] = useState([]);
  const [secondParent, setSecondParent] = useState({});
  const [thirdCatalogList, setThirdCatalogList] = useState([]);
  const [thirdParent, setThirdParent] = useState({});
  const [thirdKeywords, setThirdKeywords] = useState({});

  function onFirstMouseOver(list, parent) {
    setSecondCatalogList(list);
    setSecondParent(parent);
    const item = list?.[0];
    if (item) {
      const list = item?.sonMroCatalogVOList || [];
      const keywords = item?.mroCatalogKeywordVOList || [];
      const parent = {
        mroCatalogId: item?.mroCatalogId,
        catalogName: item?.catalogName,
      };
      onSecondMouseOver(list, parent, keywords);
    } else {
      setThirdCatalogList([]);
    }
  }

  function onSecondMouseOver(list, parent, keywords) {
    setThirdCatalogList(list);
    setThirdParent(parent);
    setThirdKeywords(keywords);
  }

  return (
    <section className="relative cursor-pointer">
      <FirstMroCatalogsPop onMouseMove={onFirstMouseOver} />
      {secondCatalogList?.length > 0 && (
        <SecondMroCatalogsPop catalogList={secondCatalogList} parent={secondParent} onMouseMove={onSecondMouseOver} />
      )}
      {secondCatalogList?.length > 0 && thirdCatalogList?.length > 0 && (
        <ThirdMroCatalogsPop catalogList={thirdCatalogList} parent={thirdParent} keywords={thirdKeywords} />
      )}
    </section>
  );
}

function FirstMroCatalogsPop({ onMouseMove }) {
  const { resourceData, catalogList } = useContext(LayoutContext);
  const { projectConfigVO } = resourceData;
  const [activeIndex, setActiveIndex] = useState(0);

  function handleMouseOver(item, index) {
    setActiveIndex(index);
    const list = item?.sonMroCatalogVOList || [];
    const parant = {
      mroCatalogId: item?.mroCatalogId,
      catalogName: item?.catalogName,
    };
    onMouseMove(list, parant);
  }

  const activeClass = (index) => {
    return activeIndex === index ? 'bg-[#EDF9FF]' : '';
  };

  return (
    <CustomScrollbar className="min-h-[480px] ml-[-20px]">
      <ul>
        {catalogList?.slice(0, 8)?.map((item, index) => (
          <li
            className={`pb-[8px] ${activeClass(index)}`}
            key={index}
            onMouseMove={() => {
              handleMouseOver(item, index);
            }}
          >
            <a
              className="flex items-center pl-[12px]"
              href={`${projectConfigVO?.lcscWwwUrl}/mro/sub/catalog.html?catalogType=first&mroCatalogId=${item.mroCatalogId}&catalogName=${item.catalogName}`}
              aria-label="item.catalogName"
              target="_blank"
            >
              {item.accessPictureLink ? (
                <Image
                  alt={item.catalogName}
                  src={item.accessPictureLink || ''}
                  width={15}
                  height={15}
                  preview={false}
                  fallback="https://static.szlcsc.com/ecp/assets/newWeb/item/default_pic.gif"
                ></Image>
              ) : (
                <div className="block size-[15px]"></div>
              )}
              <span className="text-[14px] text-[black] leading-[32px] ml-[9px]">{item.catalogName}</span>
            </a>
            <div className="p-[0_20px_0_34px] leading-[16px] clamp-[2] text-[12px] text-[#999]">
              {item.mroCatalogKeywordVOList?.map((v, k) => (
                <a
                  key={k}
                  index={k}
                  className="inline-block mr-[3px]"
                  href={v.keywordLink}
                  aria-label={v.catalogKeyword}
                  target="_blank"
                >
                  {v.catalogKeyword}
                </a>
              ))}
            </div>
          </li>
        ))}
        <li>
          <a
            className="h-[38px] block text-center leading-[38px] text-[#199fe9] bg-[#e6f6ff] hover:bg-[#179be7] hover:text-[white] text-[14px]"
            href={`${projectConfigVO?.lcscWwwUrl}/mro/sub/catalog.html?catalogType=all&mroCatalogId=`}
            target="_blank"
          >
            查看更多
          </a>
        </li>
      </ul>
    </CustomScrollbar>
  );
}

function SecondMroCatalogsPop({ catalogList, parent, onMouseMove }) {
  const { resourceData } = useContext(LayoutContext);
  const { projectConfigVO } = resourceData;

  const [activeIndex, setActiveIndex] = useState(0);

  function handleMouseOver(index, item) {
    setActiveIndex(index);
    const list = item?.sonMroCatalogVOList || [];
    const keywords = item?.mroCatalogKeywordVOList || [];
    const parent = {
      mroCatalogId: item?.mroCatalogId,
      catalogName: item?.catalogName,
    };
    onMouseMove(list, parent, keywords);
  }

  const activeClass = (index) => {
    return activeIndex === index ? 'bg-[#EDF9FF] text-[#0093e6]' : 'text-[black] ';
  };

  return (
    <CustomScrollbar
      className="absolute bg-[#f7f7f7] left-[222px] top-[-20px] w-[242px] h-[558px] overflow-auto rounded-[8px] py-[20px]
      shadow-[0_6px_16px_0_rgba(0,0,0,0.08)]"
    >
      <ul>
        <li className={`h-[40px] leading-[40px] font-[400] text-[14px] text-[#0093e6] pl-[20px]`}>所有类别</li>
        {catalogList?.map((item, index) => (
          <li
            className={`leading-[40px] font-[400] text-[14px] pl-[20px] line-clamp-1 ${activeClass(index)}`}
            key={index}
            onMouseMove={() => {
              handleMouseOver(index, item);
            }}
          >
            <a
              href={`${projectConfigVO?.lcscWwwUrl}/mro/sub/catalog.html?catalogType=second&mroCatalogId=${item.mroCatalogId}&catalogName=${item.catalogName}&parentCatalogName=${parent?.catalogName}&parentMroCatalogId=${parent?.mroCatalogId}`}
              target="_blank"
              aria-label={item.catalogName}
            >
              {item.catalogName}
            </a>
          </li>
        ))}
      </ul>
    </CustomScrollbar>
  );
}

function ThirdMroCatalogsPop({ catalogList, keywords }) {
  const { resourceData } = useContext(LayoutContext);
  const { projectConfigVO } = resourceData;
  const [activeIndex, setActiveIndex] = useState(0);

  function activeImageClass(index) {
    return activeIndex === index ? 'border-[1px] border-solid border-[#0093e6] box-border' : '';
  }

  function activeTextClass(index) {
    return activeIndex === index ? 'text-[#0093e6]' : '';
  }

  function handleMouseOver(index) {
    setActiveIndex(index);
  }

  return (
    <CustomScrollbar className="absolute bg-[white] left-[464px] top-[-20px] w-[400px] h-[558px] overflow-auto rounded-[8px] py-[20px] shadow-[0_6px_16px_0_rgba(0,0,0,0.08)]">
      <ul className="flex flex-wrap pl-[10px] pr-[20px]">
        {catalogList.map((item, index) => (
          <li
            key={index}
            className="font-[400] text-[14px] text-[black] hover:text-[#0093e6] inline-block w-[65px] m-[10px] text-center"
            onMouseOver={() => {
              handleMouseOver(index);
            }}
          >
            <a
              className="block"
              href={`${projectConfigVO?.lcscListUrl}/catalog/${item.catalogId}.html?mro=1`}
              aria-label={item.catalogName}
              target="_blank"
            >
              <Image
                className={`block ${activeImageClass(index)}`}
                width={65}
                height={65}
                src={item.accessPictureLink}
                preview={false}
                fallback="https://static.szlcsc.com/ecp/assets/newWeb/item/default_pic.gif"
              ></Image>
              <span className={`text-[12px] line-clamp-2 ${activeTextClass(index)}`}>{item.catalogName}</span>
            </a>
          </li>
        ))}
      </ul>
      <ul className="flex flex-wrap pr-[20px] pl-[20px]">
        {keywords?.map((item, index) => (
          <li key={index} className="mr-[22px] mt-[16px]">
            <a className="text-[#0093e6]" href={item.keywordLink} aria-label={item.catalogKeyword} target="_blank">
              {item.catalogKeyword}
            </a>
          </li>
        ))}
      </ul>
    </CustomScrollbar>
  );
}
